// eslint-disable react-hooks/exhaustive-deps
import React, { useState, useEffect, useRef } from 'react';
import { Common } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import { effects, selectors } from './slice';
import { Relative, SearchBarWrapper, IconClose } from './styled';
import options, { recentOptions } from './options';

const { Input, Autocomplete, Iconmoon, IconWrapper } = Common;

const Mobile = () => {
  const [isSearchBarVisible, setVisibilitySearchBar] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const { result, recent } = useSelector(selectors);

  const inputRef = useRef(null);

  const handleOutsideClick = (e) => {
    // In antd if we only use `inputRef` as input ref, it will point to
    // the **input component** instead of the HTML component
    // thus we use `inputRef.current.input` instead of `inputRef.current`
    if (inputRef.current && !inputRef.current.input.contains(e.target)) {
      setVisible(false);
    }
  };

  const debouncedSearch = debounce(
    (value) => dispatch(effects.getSearchResult(value)),
    500,
  );

  const handleSelect = debounce(() => setKeyword(''), 500);

  const onFocus = () => {
    setVisible(true);
    dispatch(effects.getSearchRecentResult());
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <Relative>
      <IconWrapper
        size="40px"
        onClick={() => setVisibilitySearchBar(!isSearchBarVisible)}
      >
        <Iconmoon size="30px" className="icon-android_search" />
      </IconWrapper>
      <SearchBarWrapper isVisible={isSearchBarVisible}>
        <Autocomplete
          options={keyword.length > 0 ? options(result) : recentOptions(recent)}
          value={keyword}
          onSelect={handleSelect}
          open={visible}
          onFocus={() => setVisible(true)}
        >
          <Input
            placeholder="Search for brand, symbol or username..."
            ref={inputRef}
            height="30px"
            value={keyword}
            onChange={(e) => {
              const { value } = e.target;
              setKeyword(value);
              debouncedSearch(value);
            }}
            onFocus={onFocus}
            width="100%"
            data-cy="top-navbar-search-input-mobile"
          />
        </Autocomplete>
        <IconClose
          size="30px"
          onClick={() => {
            setVisibilitySearchBar(false);
          }}
        >
          <Iconmoon size="15px" className="icon-compose_close" />
        </IconClose>
      </SearchBarWrapper>
    </Relative>
  );
};

export default Mobile;
